import React from 'react';
import PropTypes from 'prop-types';
import { DotNotification, FlexTableCol, FlexTableRow, TargetStatus } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { PRELIMINARY } from 'constants/observationStatuses';

import s from './styles.module.scss';

const ReportsHistoryRow = ({
  openedByPatient,
  deviceStatus,
  createDate,
  reportBy,
  id,
  t,
  reviewStatus,
}) => (
  <FlexTableRow className={s.row} to={`/report/${id}`} component={Link}>
    <FlexTableCol className={s.name}>
      {!openedByPatient && <DotNotification className={s.dot} />}
      <strong>{createDate}</strong>
    </FlexTableCol>
    <FlexTableCol>{reportBy}</FlexTableCol>
    <FlexTableCol>
      <TargetStatus className={s.targetStatus} variant={deviceStatus} />
    </FlexTableCol>
    <FlexTableCol>
      {reviewStatus === PRELIMINARY
        ? t('reports.reviewStatuses.unread')
        : t('reports.reviewStatuses.read')}
    </FlexTableCol>
  </FlexTableRow>
);

ReportsHistoryRow.propTypes = {
  deviceStatus: PropTypes.oneOf(['danger', 'warning', 'success']),
  id: PropTypes.string.isRequired,
  createDate: PropTypes.string.isRequired,
  reportBy: PropTypes.string,
  openedByPatient: PropTypes.bool,
  reviewStatus: PropTypes.oneOf(['preliminary', 'final', 'registered']).isRequired,
  t: PropTypes.func.isRequired,
};

ReportsHistoryRow.defaultProps = {
  openedByPatient: false,
  reportBy: null,
  deviceStatus: null,
};

export default withTranslation()(ReportsHistoryRow);
